<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="searchBar">
        <el-form-item label="厂商">
          <company-select v-model="tableData.search.company_id" clearable @change="companyChange"/>
        </el-form-item>
        <el-form-item label="型号">
          <model-select v-model="tableData.search.model" clearable :company-id="tableData.search.company_id" :key="tableData.search.company_id"/>
        </el-form-item>
        <el-form-item label="MAC批次">
          <mac-batch-select v-model="tableData.search.mac_batch_no" prop="batch_no" clearable :company-id="tableData.search.company_id" :key="tableData.search.company_id"/>
        </el-form-item>
        <el-form-item label="生成状态">
          <el-select v-model="tableData.search.status" clearable>
            <el-option v-for="item in orderStatus" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="status" slot-scope="{row}">
        <span v-html="formatData(row.status, orderStatus)"></span>
        <template v-if="row.status === 2 || row.status === 5">
          <el-tooltip effect="dark" placement="top-start">
            <el-button type="text" icon="el-icon-info" class="info"></el-button>
            <template slot="content">
              <span>{{row.err_msg}}</span>
            </template>
          </el-tooltip>
        </template>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addOrderMac')" size="small" type="primary" @click="add">添加订单</el-button>
      </template>
      <template v-if="hasApi(['downloadOrderMac','deleteOrderMac'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button type="text" @click="show(row)">查看</el-button>
            <el-button v-if="checkApi('downloadOrderMac')" type="text" @click="download(row)" :disabled="row.status === 2 || row.status === 5">下载</el-button>
            <el-button v-if="checkApi('deleteOrderMac')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <add-order v-if="addOrder.visible" :dialog-data="addOrder" @table-reload="getTableList"/>
    <order-info v-if="orderInfo.visible" :dialog-data="orderInfo"/>
  </div>
</template>

<script>
  import AddOrder from "./dialog/AddOrder"
  import OrderInfo from "./dialog/OrderInfo"
  import CompanySelect from "@view/components/select/CompanySelect"
  import ModelSelect from "@view/components/select/ModelSelect"
  import {orderStatus} from "@utils/formatList"
  import MacBatchSelect from "@view/components/select/MacBatchSelect"
  export default {
    name: "index",
    components: {OrderInfo,AddOrder,CompanySelect,ModelSelect,MacBatchSelect},
    data() {
      return {
        orderStatus,
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "订单号", property: "order_no"},
            {label: "生成时间", property: "create_at"},
            {label: "厂商", property: "company.name"},
            {label: "SN前缀", property: "sn_prefix"},
            {label: "MAC批次", property: "mac_batch_no"},
            {label: "型号", property: "model"},
            {label: "授权数", property: "quantity"},
            {label: "MAC数", property: "mac_number"},
            {label: "状态", property: "status", format: orderStatus},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getOrderMac",
          search: {
            company_id: "",
            mac_batch_no: "",
            model: "",
            status: "",
          },
        },
        addOrder: {title: "添加订单", visible: false, width: 800},
        orderInfo: {title: "订单详情", visible: false, width: 800, row: null, hideBtn: true},
      }
    },
    methods: {
      companyChange() {
        this.tableData.search.mac_batch_no = "";
        this.tableData.search.model = "";
      },
      add() {
        this.addOrder.visible = true;
      },
      show(row) {
        this.orderInfo.visible = true;
        this.orderInfo.row = row;
      },
      async download(row) {
        let nv = {order_id: row.id};
        let blob = await this.$Http.downloadOrderMac(nv, {responseType: "blob"});
        if (blob) {
          this.downloadFile(blob.name, blob);
        }
      },
      remove(row) {
        this.openConfirm("删除该MAC订单", async ()=> {
          let nv = {order_id: row.id};
          let res = await this.$Http.deleteOrderMac(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      async getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
